export enum PowerUnits {
  WATTS = 'W',
  KILOWATTS = 'kW',
  MEGAWATTS = 'MW',
  GIGAWATTS = 'GW',
  TERAWATTS = 'TW',
  PETAWATTS = 'PW',
}

export enum EnergyUnits {
  WATT_HOURS = 'Wh',
  KILOWATT_HOURS = 'kWh',
  MEGAWATT_HOURS = 'MWh',
  GIGAWATT_HOURS = 'GWh',
  TERAWATT_HOURS = 'TWh',
  PETAWATT_HOURS = 'PWh',
}

export enum CarbonUnits {
  GRAMS_CO2EQ_PER_KILOWATT_HOUR = 'gCO₂eq/kWh',
  CO2EQ_PER_KILOWATT_HOUR = 'CO₂eq/kWh',
  CO2EQ_PER_HOUR = 'CO₂eq/h',
}
